module.exports = __webpack_public_path__ + "img/computer.37f71f1d.png";